(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('BookCalendarController', BookCalendarController);

    BookCalendarController.$inject = ['$scope', '$location', '$window', '$mdDialog', '$mdMedia', 'Principal', 'LoginService', '$state', 'TimingInfo', 'ScheduleInfoCustom', 'ServiceItemCustom', 'ServiceCategoryCustom', '$translate', '$localStorage', '$timeout', 'ServantCustom', 'CompanyCustom'];

    function BookCalendarController($scope, $location, $window, $mdDialog, $mdMedia, Principal, LoginService, $state, TimingInfo, ScheduleInfoCustom, ServiceItemCustom, ServiceCategoryCustom, translate, $localStorage, $timeout, ServantCustom, CompanyCustom) {
        var vm = this;
        vm.schedulerApi = {refresh: 'not set'};
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.categoryName = categoryName;
        vm.storeInDefaults = storeInDefaults;
        vm.getFromDefaults = getFromDefaults;
        vm.startRefreshTimer = startRefreshTimer;
        vm.updateServantList = updateServantList;
        vm.onReserveOnlyChanged = onReserveOnlyChanged;
        vm.onReserveOnlyChangedReset = onReserveOnlyChangedReset;
        vm.updateTimeBoard = updateTimeBoard;
        vm.openFilterDialog = openFilterDialog;
        vm.onCategoryChanged = onCategoryChanged;
        vm.onServiceChanged = onServiceChanged;
        vm.onServantChanged = onServantChanged;
        vm.onServantChipClick = onServantChipClick;
        vm.onServiceChipClick = onServiceChipClick;
        vm.lastUpdate;
        vm.selectedServiceListChanged = false;

        vm.firstHour = 6;
        vm.lastHour = 20;
        vm.servantList = [];
        vm.selectedService = {};
        vm.selectedServiceList = [];
        vm.selectedServiceChips = [];
        vm.selectedServant = null;
        vm.selectedServantList = [];
        vm.hourList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
        vm.reserveOnlyMode = true;
        vm.canSelectMultiService = false;
        vm.selectedServantServiceList = [];
        vm.selectedServantTitle = '';
        vm.querySearch = querySearch;
        vm.gotoNewReserve_flex = gotoNewReserve_flex;
        vm.selectionMode = null;
        vm.allServant = false;
        vm.setDayView = setDayView;
        vm.allServant_changed = allServant_changed;
        vm.servantChipsClick = servantChipsClick;
        vm.getChipsClass = getChipsClass;

        //arrow
        vm.slide = slide;
        vm.showLeftArrow = true;
        vm.showRightArrow = true;

        vm.getCalendarClass = getCalendarClass;
        vm.defaultCustomTime = false;


        checkCompanySetting();
        ServiceCategoryCustom.getServiceCategoriesByCurrentCompany().query().$promise.then(function (result) {

            var path = $location.path();
            if ((path == '/supplierPanel/calendar' || path == '/calendar') && (result[0].company.appVersion == 'v1' || result[0].company.appVersion == null)) {
                $window.location.href = '/#/supplierPanel/timeBoard';
            }

            vm.categories = result;

            angular.forEach(result, function (item) {
                item.categoryName = categoryName(item.categoryName)
            })
            onCategoryChanged();
        });
        $scope.$watch('reserveOnlyMode', function (reserveOnlyMode) {


        });


        vm.filterProperties = {};
        vm.getFromDefaults();
        getAllServantList();


        // getAllServiceItemsByCurrentCompany();
        // addAllServicesAsSelected();


        vm.startRefreshTimer();

        //vm.serviceItems=ServiceItemCustom.getActiveServiceItemsByCurrentCompany().query(function(list){
        //   if(list && list.length>0) {
        //
        //       vm.selectedId=list[0].id;
        //       updateTimeBoard();
        //   }
        //
        //});

        function checkCompanySetting() {

            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {
                vm.company = result;
                if (vm.company.customSettingObject && vm.company.customSettingObject.defaultCustomTimeActive)
                    vm.defaultCustomTime = vm.company.customSettingObject.defaultCustomTimeActive;
            })

        }

        function updateServantList(then) {


            //  vm.selectedServantList = [];
            // vm.selectedServant=null;
            if (!vm.selectedServiceList || vm.selectedServiceList.length == 0) {
                // vm.selectedServantList = [];
                if (then)
                    then();
            }
                // else {
                //     vm.servantList = [];
                //     var index=0;
                //     if(vm.selectedServiceList.length>0) {
                //         angular.forEach(vm.selectedServiceList, function (service) {
                //             index++;
                //             ServiceItemCustom.getServiceServants(service).query(function (servants) {
                //                 angular.forEach(servants, function (serviceServant) {
                //                     var isInList = false;
                //                     angular.forEach(vm.servantList, function (servant) {
                //                         if (serviceServant.id == servant.id)
                //                             isInList = true;
                //                     })
                //                     if (!isInList) {
                //                         vm.servantList.push(serviceServant);
                //
                //                     }
                //
                //                 });
                //
                //                 if (index == vm.selectedServiceList.length) {
                //                     if (vm.servantList.length > 0) {
                //                         vm.selectedServant = vm.servantList[0].id;
                //
                //                         vm.selectedServantTitle = vm.servantList[0].servantName;
                //                         vm.selectedServantList.push(vm.servantList[0].id);
                //                     }
                //                     onServantChanged();
                //                     updateChipLists();
                //                     if (then)
                //                         then();
                //
                //                 }
                //
                //
                //             })
                //
                //
                //         })
            //     }
            else {
                vm.servantList = [];
                var index = 0;
                if (vm.selectedServiceList.length > 0) {

                    // ServantCustom.getServantsHaveServicesByCurrentCompany().query(function (servants) {
                    //
                    //     vm.servantList = servants;
                    // })
                    //
                    //     if (vm.servantList.length > 0) {
                    //         vm.selectedServant = vm.servantList[0].id;
                    //
                    //         vm.selectedServantTitle = vm.servantList[0].servantName;
                    //         vm.selectedServantList.push(vm.servantList[0].id);
                    //     }
                    //     onServantChanged();
                    //     updateChipLists();

                    getAllServantList();

                    if (then)
                        then();
                } else {
                    if (then)
                        then();
                }
            }

        }

        function findAvailableServiceByServant(servantId) {

        }

        vm.onServantListChanged = function () {

        }

        function addAllServicesAsSelected() {
            vm.selectedServiceList = [];
            angular.forEach(vm.serviceItems, function (si) {
                var selected = false;
                vm.selectedServiceList.push(si.id);

            });
        }

        function onServiceChanged(then) {
            vm.selectedServiceList = [];
            if (!vm.selectedServiceListChanged)
                if (vm.selectedService == 0) {
                    addAllServicesAsSelected();
                } else {
                    if (vm.selectedService)
                        vm.selectedServiceList.push(vm.selectedService);
                }


        }

        function afterSelectedServiceChanged(then) {
            checkIfSelectedServiceListIsValid();
            updateServantList(then);
        }

        function checkIfSelectedServiceListIsValid() {
            var isValid = true;
            angular.forEach(vm.selectedServiceList, function (ssi) {
                var selectedServiceIsValid = false;
                angular.forEach(vm.serviceItems, function (si) {
                    if (ssi == si.id)
                        selectedServiceIsValid = true;
                })
                if (!selectedServiceIsValid)
                    isValid = false;
            })
            if (!isValid) {

                vm.selectedService = {};
                vm.selectedServiceList = [];
                vm.selectedServantList = [];
            }

        }

        function onServantChipClick(sr) {
            if (sr) {
                vm.selectedServant = sr.id;
                vm.selectedServantTitle = sr.title;
            }
            onServantChanged();
            // updateChipLists();
            // updateTimeBoard();

        }

        function searchText() {
        }

        function onServiceChipClick(si) {

            vm.selectedServiceListChanged = true;

            si.selected = !si.selected;
            if (si.selected) {
                if (!vm.canSelectMultiService) {
                    vm.selectedServiceList = [];
                }

                vm.selectedServiceList.push(si.id);
            } else {
                vm.selectedServiceList = vm.selectedServiceList.filter(function (s) {
                    return s != si.id;
                })
            }
            afterSelectedServiceChanged(function () {
                updateChipLists();
                updateTimeBoard();
            })
        }

        function onServantChanged() {

            //  if (!vm.canSelectMultiService) {
            vm.selectedServantList = [];
            if (vm.selectedServant) {
                vm.selectedServantList.push(vm.selectedServant);

                if (!$scope.calendarFilter)
                    $scope.calendarFilter = {};

                $scope.calendarFilter.selectedServant = vm.selectedServant;
                $scope.calendarFilter.servantTitle = getServantTitle(vm.selectedServant);


                ServiceItemCustom.getServiceItemsByServantId(vm.selectedServant).query(function (result) {

                    vm.selectedServantServiceList = result;

                    // vm.selectedServiceList = result;
                    // vm.serviceItems = result;
                    updateChipLists();
                    updateTimeBoard();

                })

            }

            //  }
        }

        function getServantTitle(servantId) {
            var result;
            angular.forEach(vm.servantList, function (item) {
                if (item.id == servantId)
                    result = item.servantName;
            })

            vm.selectedServantTitle = result;
            return result;
        }

        function onReserveOnlyChanged() {

            // vm.selectedServiceListChanged=false;
            // if (vm.reserveOnlyMode) {
            //     vm.canSelectMultiService = true;
            //         addAllServicesAsSelected();
            // }
            // else {
            //     vm.selectedServiceList=[];
            //     if(vm.serviceItems && vm.serviceItems.length>0 )
            //         vm.selectedServiceList.push(vm.serviceItems[0].id);
            //     vm.canSelectMultiService = false;
            //
            // }
            // afterSelectedServiceChanged(function(){
            //     updateChipLists();
            //     updateTimeBoard();
            // });
        }

        function onReserveOnlyChangedReset() {
            onReserveOnlyChanged();
        }

        function onCategoryChanged() {

            if (vm.selectedCategoryId)
                ServiceItemCustom.getActiveServiceItemsByCategory(vm.selectedCategoryId).query(function (list) {
                    vm.serviceItems = list;
                    /*   if(list && list.length>0) {
                     vm.selectedId=list[0].id;
                     vm.storeInDefaults();
                     updateTimeBoard();
                     }*/
                    afterSelectedServiceChanged(function () {
                        updateChipLists();
                        updateTimeBoard();
                    });

                });
            else
                getAllServiceItemsByCurrentCompany();


        }

        function getAllServiceItemsByCurrentCompany() {
            ServiceItemCustom.getServiceItemsByCurrentCompany().query(function (list) {
                vm.serviceItems = list;
                if (list && list.length > 0) {
                    //vm.getFromDefaults();
                    var isDefaultInList = false;
                    if (vm.selectedId != undefined)
                        angular.forEach(list, function (item) {
                            if (item.id == vm.selectedId)
                                isDefaultInList = true;
                        });

                    if (vm.selectedId == undefined || !isDefaultInList) {
                        vm.selectedId = list[0].id;
                        vm.storeInDefaults();
                    }
                    afterSelectedServiceChanged(function () {
                        updateChipLists();
                        updateTimeBoard();
                    });

                }
                addAllServicesAsSelected();

            });
        }

        function startRefreshTimer() {

            var timeOut = 300000;
            // if(!vm.runBefore )
            // {
            $timeout(function () {
                vm.updateTimeBoard();
                setInterval(function () {
                    vm.updateTimeBoard();
                    vm.runBefore = true;
                }, timeOut)
            }, 1000);

            // }


        }

        // vm.updateTimeBoard = updateTimeBoard;
        function updateTimeBoard(then) {

            vm.calendarFilter = makeCalendarFilter();


            //  if ((vm.canSelectMultiService && vm.calendarFilter.serviceList.length > 0)) {
            storeInDefaults();
            //    }
            //    else {
            //  openFilterDialog();
            //     }
            if (then)
                then();
            vm.lastUpdate = new Date();
        }

        function makeCalendarFilter() {
            updateChipLists();

            var calendarFilter = {};
            calendarFilter.firstHour = vm.firstHour;
            calendarFilter.lastHour = vm.lastHour;
            calendarFilter.serviceList = [];
            calendarFilter.servantList = [];
            calendarFilter.reserveTypes = [];
            calendarFilter.reserveOnlyMode = vm.reserveOnlyMode;
            calendarFilter.selectedServant = null;
            if (vm.selectionMode)
                calendarFilter.selectionMode = vm.selectionMode;


            angular.forEach(vm.selectedServiceList, function (service) {
                calendarFilter.serviceList.push(service);
                if (!vm.selectedServantServiceList) {
                    if (calendarFilter.selectedServantServiceList)
                        vm.selectedServantServiceList = calendarFilter.selectedServantServiceList;
                }
            })

            calendarFilter.servantList = [];
            if (!vm.allServant) {
                angular.forEach(vm.selectedServantList, function (servant) {
                    if (calendarFilter.servantList.indexOf(servant) == -1)
                        calendarFilter.servantList.push(servant);
                })
            } else {
                angular.forEach(vm.selectedServantChips, function (servant) {
                    if (servant.selected && calendarFilter.servantList.indexOf(servant) == -1)
                        calendarFilter.servantList.push(servant.id);
                })
            }
            if (vm.reserveOnlyMode) {
                calendarFilter.reserveTypes.push('RESERVED')
            } else {
                calendarFilter.reserveTypes.push('RESERVED');
                calendarFilter.reserveTypes.push('CANCELED');
                calendarFilter.reserveTypes.push('FREE');
            }

            if (vm.selectedServant)
                calendarFilter.selectedServant = vm.selectedServant;
            if (vm.selectedServantTitle)
                calendarFilter.servantTitle = vm.selectedServantTitle;
            if (vm.selectedServantServiceList) {
                calendarFilter.selectedServantServiceList = vm.selectedServantServiceList;
            }


            return calendarFilter;

        }

        function updateChipLists() {

            return;
            vm.selectedServiceChips = [];
            vm.selectedServantChips = [];
            var servantFound = false;
            angular.forEach(vm.servantList, function (si) {
                var selected = false;
                if (vm.selectedServantList.indexOf(si.id) > -1) {
                    selected = true;
                }

                if (vm.selectedServant && vm.selectedServant == si.id)
                    servantFound = true;

                vm.selectedServantChips.push({id: si.id, title: si.servantName, selected: selected});

            });

            if (!servantFound && vm.servantList && vm.servantList.length > 0) {
                vm.selectedServant = vm.servantList[0].id;
                onServantChanged();
            }

            // angular.forEach(vm.serviceItems, function (si) {
            //     var selected=false;
            //     if (vm.selectedServiceList.indexOf(si.id) > -1) {
            //
            //        selected=true;
            //     }
            //     if(!si.color)
            //     si.color='COLOR';
            //     vm.selectedServiceChips.push({id: si.id, title: si.itemTitle, color: si.color,selected:selected});
            //
            // });


            //console.log('vm.serviceItems');
            //console.log(vm.serviceItems);
            /*     if (vm.selectedServiceList)
                     angular.forEach(vm.serviceItems, function (si) {
                         if (vm.selectedServiceList.indexOf(si.id) > -1) {
                             console.log(si);
                             vm.selectedServiceChips.push({id: si.id, title: si.itemTitle, color: si.color});
                         }

                     });
                 var validSelectedServantList = [];
                 if(vm.selectedServantList)
                 angular.forEach(vm.selectedServantList, function (ss) {

                     var isInList = false;
                     if(vm.servantList)
                     angular.forEach(vm.servantList, function (si) {
                         if (si.id == ss)
                             isInList = true;
                     })
                     if(isInList)
                          validSelectedServantList.push(ss);

                 });
                 vm.selectedServantList=validSelectedServantList;
                 angular.forEach(vm.servantList, function (si) {
                     if (vm.selectedServantList.indexOf(si.id) > -1) {
                         vm.selectedServantChips.push({id: si.id, title: si.servantName});
                     }

                 });*/
        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }

        function getAllServantList() {

            vm.selectedServantList = [];
            // vm.selectedServant=null;
            vm.servantList = [];
            var index = 0;
            ServantCustom.getServantsHaveServicesByCurrentCompany().query().$promise.then(function (items) {

                vm.selectedServantList = [];
                vm.servantList = items;
                initAllServantChips();
                if (vm.servantList) {
                    vm.selectedServantList.push(vm.servantList[0].id);
                    if (!vm.calendarFilter.selectedServant) {
                        vm.selectedServant = vm.servantList[0].id;
                        vm.selectedServantTitle = vm.servantList[0].servantName;
                    } else {
                        vm.selectedServant = vm.calendarFilter.selectedServant;
                        if (vm.calendarFilter.servantTitle)
                            vm.selectedServantTitle = vm.calendarFilter.servantTitle;
                    }


                }

                onServantChanged();

            })

        }

        function storeInDefaults() {
            $localStorage.calendarFilter = vm.calendarFilter;
            $localStorage.selectedServiceList = vm.selectedServiceList;
            $localStorage.selectedServantList = vm.selectedServantList;
            $localStorage.selectedService = vm.selectedService;
            $localStorage.selectedServant = vm.selectedServant;
            $localStorage.reserveOnlyMode = vm.reserveOnlyMode;
            $localStorage.selectedServantServiceList = vm.selectedServantServiceList;
            $localStorage.calendarFilter.showAllServant = vm.allServant;

            if (!vm.selectedServantTitle) {
                getServantTitle(vm.selectedServant)
            }

            $localStorage.servantTitle = vm.selectedServantTitle;
            //if(vm.selectedId!=undefined)
            //$localStorage.selectedId=vm.selectedId;
        }

        function getFromDefaults() {

            // vm.selectedService = $localStorage.selectedService;
            // vm.selectedServant = $localStorage.selectedServant;
            if (!$localStorage.selectedServiceList)
                $localStorage.selectedServiceList = [];
            if (!$localStorage.selectedServantList)
                $localStorage.selectedServantList = [];
            // if(!$localStorage.reserveOnlyMode)
            $localStorage.reserveOnlyMode = true;

            // vm.selectedServiceList = $localStorage.selectedServiceList;
            // vm.selectedServantList = $localStorage.selectedServantList;

            vm.reserveOnlyMode = $localStorage.reserveOnlyMode;
            if (!$localStorage.calendarFilter)
                makeDefaultCalendarFilter()
            vm.calendarFilter = $localStorage.calendarFilter;
            if (vm.calendarFilter)
                vm.firstHour = vm.calendarFilter.firstHour;
            vm.lastHour = vm.calendarFilter.lastHour;
            //   onReserveOnlyChanged();
            //onServiceChanged();
            //onServantChanged();

            if (!$localStorage.selectedServantServiceList)
                $localStorage.selectedServantServiceList = [];

            if ($localStorage.calendarFilter.showAllServant != null || $localStorage.calendarFilter.showAllServant != undefined) {
                vm.allServant = $localStorage.calendarFilter.showAllServant;
                vm.allServant_changed();
            }


            if (vm.calendarFilter) {
                if (vm.calendarFilter.selectedServant)
                    vm.selectedServant = vm.calendarFilter.selectedServant;
                if (vm.calendarFilter.selectedServantServiceList)
                    vm.selectedServantServiceList = vm.calendarFilter.selectedServantServiceList;
                if (vm.calendarFilter.servantTitle)
                    vm.selectedServantTitle = vm.calendarFilter.servantTitle;

            }

            // if(!$localStorage.selectedServant)
            //     $localStorage.selectedServant=null;


            //console.log('reading from storage :'+vm.selectedId)
            //if($localStorage.selectedId!=undefined)
            //{
            //
            //    var serviceList=[];
            //    vm.selectedId=$localStorage.selectedId;
            //    console.log('exista storage :'+vm.selectedId)
            //}
        }

        function querySearch(query) {

            var temp = [];


            // angular.forEach($ctrl.serviceItems, function (item) {
            //     if (item.itemTitle.indexOf(query) > -1) {
            //         temp.push(item);
            //     } else if (query == null) {
            //         temp = $ctrl.serviceItems;
            //     }
            // })

            return temp;

        }

        function makeDefaultCalendarFilter() {
            $localStorage.calendarFilter = {firstHour: 6, lastHour: 21};

        }

        function gotoNewReserve_flex() {
            var s_date, e_date = null;


            s_date = new Date();
            s_date.setMinutes(0);
            s_date = s_date.toISOString();

            $state.go('supplierPanel.new-reserve-modal', {
                serviceItemId: null,
                servantId: vm.selectedServant,
                start_date: s_date,
                end_date: e_date,
                hasCustomTime: vm.defaultCustomTime
            });

        }

        function setDayView() {

        }

        function allServant_changed() {
            if (vm.allServant) {
                vm.selectionMode = 'day';
            } else
                vm.selectionMode = 'week';


            var slideVar = window.setTimeout(function () {
                checkArrowStat();
                window.clearInterval(slideVar);
            }, 20);

            vm.updateTimeBoard();
        }

        function initAllServantChips() {
            vm.selectedServantChips = [];
            angular.forEach(vm.servantList, function (srv) {
                var item = srv;
                item.selected = true;
                vm.selectedServantChips.push(item);
            })

        }

        function servantChipsClick(item) {
            if (!vm.selectedServantChips)
                return;

            angular.forEach(vm.selectedServantChips, function (srv) {

                if (srv.id == item.id)
                    srv.selected = !srv.selected;
            })

            vm.updateTimeBoard();
        }

        function getChipsClass(item) {
            if (item.selected)
                return 'chips-checked'
            else
                return 'chips-unchecked'
        }


        function slide(direction) {
            var container = document.getElementById('servantChipsList');
            var scrollCompleted = 0;
            var step = 400;

            if (direction == 'left') {
                container.scrollLeft -= step;
            } else {
                container.scrollLeft += step;
            }

            checkArrowStat();

        }

        function checkArrowStat() {
            var container = document.getElementById('servantChipsList');

            if (!container)
                return;
            //var containerSize = 900;
            var size = container.clientWidth;
            var scrollWidth = container.scrollWidth;

            if (size < scrollWidth) {
                if (container.scrollLeft >= 0) {
                    vm.showLeftArrow = true;
                    vm.showRightArrow = false;
                } else if (container.scrollLeft < 0 && size - scrollWidth < container.scrollLeft) {
                    vm.showLeftArrow = true;
                    vm.showRightArrow = true;
                }
                if (size - scrollWidth == container.scrollLeft || (size - scrollWidth >= container.scrollLeft - 2 && size - scrollWidth <= container.scrollLeft + 2)) {
                    vm.showLeftArrow = false;
                    vm.showRightArrow = true;
                }

                // vm.showLeftArrow = true;
                // vm.showRightArrow = true;
            } else {
                vm.showLeftArrow = false;
                vm.showRightArrow = false;
            }
        }

        function getCalendarClass() {
            if (vm.allServant)
                return 'table-container-all-servant';
            else
                return 'table-container';
        }

        function openFilterDialog(ev) {
            var useFullScreen = ($mdMedia('sm') || $mdMedia('xs')) && vm.customFullscreen;
            $mdDialog.show({
                controller: CalendarFilterDialogController,
                templateUrl: 'app/time-board/filter-dialog.template.html',
                locals: {dialogData: vm, refreshTimingInfoMethod: updateTimeBoard},
                controllerAs: 'vm',
                targetEvent: vm,
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: useFullScreen
            })
                .then(function (answer) {
                    $mdDialog.hide();
                }, function () {

                });

        };


        vm.openActionMenu = function () {
            vm.showMenu();
            // gotoNewReserve_flex();
        }

        vm.newReserve_click = function () {
            // vm.showMenu2(false);
            gotoNewReserve_flex();
        }

        // function showMenu(state)
        // {
        //     debugger;
        //     var box = document.getElementById('actionsMenu');
        //
        //     if(state) // open
        //         box.style.display = 'flex';
        //     else
        //         box.style.display = 'none';
        // }
        // window.addEventListener('mouseup', function(event){
        //     var box = document.getElementById('actionsMenu');
        //     if(!box)
        //         return;
        //     if (event.target != box && event.target.parentNode != box){
        //         box.style.display = 'none';
        //     }
        // });

        vm.showMenu = function () {
            document.getElementById("myDropdown").classList.toggle("show");
        }

        window.onclick = function (event) {
            var btn = document.getElementById('new-btn');

            if (!btn)
                return;
            if (event.target != btn && event.target.parentNode != btn) {
                var dropdowns = document.getElementsByClassName("dropdown-content");
                var i;
                for (i = 0; i < dropdowns.length; i++) {
                    var openDropdown = dropdowns[i];
                    if (openDropdown.classList.contains('show')) {
                        openDropdown.classList.remove('show');
                    }
                }
            }
        }

        vm.newCloseTime_click = function () {
            addServantExceptionTimes('CLOSE');
        }
        vm.newOpenTime_click = function () {
            addServantExceptionTimes('OPEN');
        }

        function addServantExceptionTimes(mode) {

            var multiServant = false;
            if (vm.servantList && vm.servantList.length > 1)
                multiServant = true;

            $state.go('supplierPanel.calendar.servantExceptionTimes', {
                availabilityMode: mode,
                defaultServantId: vm.selectedServant
            });

            return;


            $mdDialog.show({
                templateUrl: 'app/components/partial-forms/servant-exception-duration/partial-form.servant-exception-duration.html',
                controller: 'ServantExceptionDurationComponentController',
                controllerAs: '$ctrl',
                resolve: {
                    entity: (function () {
                        return {
                            defaultServantId: vm.selectedServant,
                            availabilityMode: mode,
                            canSelectServant: multiServant

                        };
                    })

                },
                // parent: angular.element(document.body),
                // targetEvent: customerFormData,
                clickOutsideToClose: true
                // fullscreen : true
            }).then(function (v) {
                updateTimeBoard();
            }, function () {
                //nothing
            });

        }


    }


    var CalendarFilterDialogController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
        var $ctrl = this;
        var vm = $ctrl.dialogData;
        $ctrl.dialogData = dialogData;
        $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;

        //$ctrl.dialogData = {
        //    id: dialogData.id,
        //    price: dialogData.price,
        //    capacity: dialogData.capacity,
        //    enable: dialogData.enable,
        //    discount: dialogData.discount,updateTimeBoard
        //    isNew:dialogData.isNew
        //};


        $ctrl.hideDialog = function () {
            $mdDialog.hide();
        };

        $ctrl.cancelDialog = function () {
            $mdDialog.cancel();
        };

    }
    CalendarFilterDialogController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils'];

})();
